export const Marquee = () => {
  const items = [
    "Premium Fleet",
    "24×7 Service",
    "Heritage Tours",
    "Local Experts",
    "Outstation Rides",
    "Fixed Fares",
  ];
  const loop = [...items, ...items];
  return (
    <section className="relative bg-jodhpur-primary py-6 overflow-hidden border-y border-white/10" data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        {loop.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-display italic text-4xl sm:text-5xl text-transparent [-webkit-text-stroke:1px_rgba(253,251,247,0.55)]">
              {t}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-jodhpur-accent" />
          </span>
        ))}
      </div>
    </section>
  );
};
